
import React from 'react';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

interface ColumnStyles {
  toggle: string;
  name: string;
  phone: string;
  status: string;
  outcome: string;
  value: string;
  date: string;
}

interface DesktopLeadTableHeaderProps {
  columnStyles: ColumnStyles;
}

const DesktopLeadTableHeader: React.FC<DesktopLeadTableHeaderProps> = ({ columnStyles }) => {
  return (
    <TableHeader>
      <TableRow className="hover:bg-transparent">
        <TableHead className={`${columnStyles.toggle} text-center rounded-none`}></TableHead>
        <TableHead className={columnStyles.name}>Name</TableHead>
        <TableHead className={columnStyles.phone}>Phone Number</TableHead>
        <TableHead className={`${columnStyles.status} pl-5`}>Status</TableHead>
        <TableHead className={`${columnStyles.outcome} pl-5`}>Outcome</TableHead>
        <TableHead className={`${columnStyles.value} pl-5`}>Revenue</TableHead>
        <TableHead className={`${columnStyles.date} rounded-none`}>Date</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default DesktopLeadTableHeader;
